// extracted by mini-css-extract-plugin
export default {"careerSection":"Career_careerSection__Zkbjm","careerWrapper":"Career_careerWrapper__Fg5RM"};